import { TrendingUp } from "lucide-react";
import { NavigationItem } from "../../types";
import { BuilderContext } from "../context";

/**
 * Insights — reports only. Employees moved to Admin (people management).
 */
export function buildInsightsSection(ctx: BuilderContext): NavigationItem | null {
  const { featureFlags } = ctx;
  if (!featureFlags.canViewReports) return null;

  const insightsChildren: NavigationItem[] = [
    { id: "reports-home", name: "Reports Home", href: "/reports" },
  ];

  return {
    id: "insights",
    name: "Insights",
    href: "/reports",
    icon: TrendingUp,
    visible: true,
    order: 5,
    children: insightsChildren,
  };
}
